<template>
  <div class="ta-total-items-found">
    {{auctions.totalRows == 1 ? $t('{total} item found', {total: auctions.totalRows}) : $t('{total} items found', {total: auctions.totalRows})}}
  </div >
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "AuctionListItemsCount",
  computed: {
    ...mapState(['auctions'])
  }
}
</script>

<style lang="scss" scoped>
  .ta-total-items-found {
    display: inline-flex;
    font-weight: bold;
  }
</style>
